import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';

import { rikHttpClient } from 'services/httpClient';
import ICreateThreadInterventionRequestBody from 'services/httpClient/requests/intervention/ICreateThreadInterventionRequestBody';
import ICreateThreadMessageInterventionRequestBody from 'services/httpClient/requests/intervention/ICreateThreadMessageInterventionRequestBody';
import ICreateThreadInterventionResponse from 'services/httpClient/responses/intervention/ICreateThreadInterventionResponse';
import ICreateThreadMessageInterventionResponse from 'services/httpClient/responses/intervention/ICreateThreadMessageInterventionResponse';

import { interventionActions } from '../index';
import { ICreateThreadRequestAction } from '../reducers/createThread/request';

function* createThread(action: PayloadAction<ICreateThreadRequestAction>) {
  try {
    const body: ICreateThreadInterventionRequestBody = {
      intervention_id: action.payload.data.interventionId,
      subject: action.payload.data.subject,
      trader_id: action.payload.data.traderId,
    };

    const { data }: AxiosResponse<ICreateThreadInterventionResponse> =
      yield call(rikHttpClient.post, `messages/thread`, body);

    if (data.thread_message_id) {
      const messageBody: ICreateThreadMessageInterventionRequestBody = {
        text: action.payload.data.message,
        thread_message_id: data.thread_message_id,
        wrote_by: 'trader',
      };

      const {
        data: message,
      }: AxiosResponse<ICreateThreadMessageInterventionResponse> = yield call(
        rikHttpClient.post,
        `messages/message`,
        messageBody,
      );

      data.messages.push(message);
    }

    yield put(
      interventionActions.createThreadSuccess({
        thread: data,
      }),
    );
    action.payload.functions.closeModal();
  } catch (err: any) {
    action.payload.functions.error(err);

    yield put(interventionActions.createThreadFailure());
  }
}

export default createThread;
